import { List } from '@denishussar/html5-game-engine';
import { AABBModel } from './AABBModel';
import { MiniGameModel, MiniGameTypeEnum } from './MiniGameModel';
import { EnvironmentModel, EnvironmentTypeEnum } from './EnvironmentModel';
import { BorderModel, BorderTypeEnum } from './BorderModel';

export class RoomModel extends AABBModel {
    public miniGameList: List<MiniGameModel> = new List<MiniGameModel>();
    public environmentList: List<EnvironmentModel> = new List<EnvironmentModel>();
    public borderList: List<BorderModel> = new List<BorderModel>();

    get aabb(): [number, number, number, number] {
        return [this.pos[0] - this.width, this.pos[1] - this.height, this.width * 3, this.height * 3];
    }

    public visible: boolean = false;
    public key: string = '';
    public x: number = 0;
    public y: number = 0;

    public constructor(public index: string) {
        super();

        this.height = 1440;
        this.width = 1920;
    }

    public addEnvironment(pos: [number, number], key: string, type: string): EnvironmentModel {
        const environment = new EnvironmentModel(EnvironmentTypeEnum[type]);
        environment.initialPos = pos;
        environment.key = key;

        this.environmentList.add(environment);

        return environment;
    }

    public addMiniGame(pos: [number, number],  key: string, type: MiniGameTypeEnum): MiniGameModel {
        const miniGame = new MiniGameModel(type);
        miniGame.initialPos = [pos[0] + this.x, pos[1] + this.y];
        miniGame.key = key;

        this.miniGameList.add(miniGame);

        return miniGame;
    }

    public addBorder(pos: [number, number], rotation: number, width: number, height: number, type:BorderTypeEnum, roomIndex: string, isOnTop: boolean): BorderModel {
        const border = new BorderModel();
        border.initialPos = pos;
        border.rotation = rotation;
        border.width = width;
        border.height = height;
        border.type = type;
        border.roomIndex = roomIndex;
        border.isOnTop = isOnTop;

        this.borderList.add(border);

        return border;
    }
}
